const buttonsSkin = {
  "simple-button": {
    composes: "btn btn-outline-dark",
    "margin-left": "5px",
    "text-wrap": "nowrap",
  },
  "bottom-space": {
    "margin-bottom": "5px",
  },
};

export default buttonsSkin;
